import {IconButton, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Stack} from "@mui/material";
import {Delete, Edit} from "@mui/icons-material";
import {AffiliationDto} from "../../../client/affiliation/AffiliationApiClient";
import {useTranslation} from "react-i18next";
import {CommonTranslKey} from "../../../common/CommonTranslKey";
import AffiliationBadgedAvatar from "../../affiliation/AffiliationBadgedAvatar";
import {ContactDto} from "../../../client/contact/ContactApiClient";
import {ContactFormatter} from "../../contact/ContactFormatter";
import {ContactAffiliationRoleFormatter} from "../../affiliation/ContactAffiliationRoleFormatter";
import {ContactAffiliationTitleFormatter} from "../../affiliation/ContactAffiliationTitleFormatter";


export interface OrganizationAffiliationListItemProps {
    affiliation: AffiliationDto;
    contact: ContactDto;
    onInvalidateClick: (affiliation: AffiliationDto, contact: ContactDto) => void;
    onUpdateClick: (affiliation: AffiliationDto, contact: ContactDto) => void;
}

export default function OrganizationAffiliationListItem(props: Readonly<OrganizationAffiliationListItemProps>) {
    const {affiliation, contact, onInvalidateClick, onUpdateClick} = props;

    const {t} = useTranslation();

    function buildSecondaryContent(affiliation: AffiliationDto) {
        return (
            <>
                <span>{ContactAffiliationRoleFormatter.formatRole(affiliation.contactAffiliationRole, t)}</span>
                <span> | </span>
                <span><em>{ContactAffiliationTitleFormatter.formatTitle(affiliation.contactAffiliationTitle,affiliation.otherContactAffiliationTitle, t)}</em></span>
                {affiliation.expertise &&
                    <>
                        <span> | </span>
                        <span><em>{affiliation.expertise}</em></span>
                    </>
                }
            </>
        );
    }

    return (
        <ListItem>
            <ListItemAvatar>
                <AffiliationBadgedAvatar affiliation={affiliation} iconType={"contact"} />
            </ListItemAvatar>
            <ListItemText primary={ContactFormatter.formatContactName(contact)} secondary={buildSecondaryContent(affiliation)} />
            <ListItemSecondaryAction>
                <Stack direction={"row"} spacing={0}>
                    <IconButton title={t(CommonTranslKey.EDIT)} disabled={!affiliation.acl.canUpdate}
                                onClick={() => onUpdateClick(affiliation, contact)}>
                        <Edit/>
                    </IconButton>
                    <IconButton title={t(CommonTranslKey.INVALIDATE)} disabled={!affiliation.acl.canInvalidate}
                                onClick={() => onInvalidateClick(affiliation, contact)}>
                        <Delete/>
                    </IconButton>
                </Stack>
            </ListItemSecondaryAction>
        </ListItem>
    );
}
